import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { config } from './config';

const firebaseConfig = {
    projectId: config.firebaseProjectId,
    apiKey: config.firebaseApiKey,
    authDomain: `${config.firebaseProjectId}.firebaseapp.com`,
    databaseURL: config.isDevelopment ? 'http://localhost:9000' : `https://${config.firebaseProjectId}.firebasedatabase.app`,
    storageBucket: `${config.firebaseProjectId}.appspot.com`,
    messagingSenderId: config.firebaseMessagingSenderId,
    appId: config.firebaseAppId,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Realtime Database
export const database = getDatabase(app);

// Initialize Storage
export const storage = getStorage(app);

// Connect to emulators in development mode
if (config.isDevelopment) {
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectDatabaseEmulator(database, 'localhost', 9000);
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('Using Firebase emulators');
} 